export default "__VITE_ASSET__DTGrqR7m__"